// @flow
import React, { useCallback, forwardRef, useRef, useImperativeHandle, useState } from 'react';
import { Input } from 'semantic-ui-react';
import * as cssTele2 from './LoginTele2.module.css';
import * as cssComviq from './LoginComviq.module.css';

type Props = {
  isComviq: boolean,
  onHasDigit: (digit: string) => void,
  maxLength?: int,
};

const DigitInputComp = ({ isComviq, onHasDigit, maxLength = 1, ...other }: Props, ref) => {
  const inputRef = useRef();
  const css = isComviq ? cssComviq : cssTele2;

  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus();
    },
  }));
  const [value, setValue] = useState('');
  const handleInputValue = useCallback(
    (event) => {
      setValue(event.target.value);
      if (onHasDigit && event.target.value !== '') {
        onHasDigit(event.target.value);
      }
    },
    [setValue, value]
  );

  return (
    <Input
      ref={inputRef}
      type="tel"
      maxLength={maxLength}
      className={css.number}
      value={value}
      onChange={handleInputValue}
      {...other}
    />
  );
};
export default forwardRef(DigitInputComp);
